<div *ngIf="visible" class="rw" [class.rw--expanded]="expanded">
    <button type="button" class="rw__bar" (click)="toggle()">
        <span class="rw__bar-icon-wrap">
            <mat-icon svgIcon="heroicons_outline:signal" class="rw__bar-icon"></mat-icon>
        </span>
        <span class="rw__bar-title" autoTranslate>Equipe remota</span>
        <span class="rw__bar-badge">{{ onlineCount }} <span autoTranslate>online</span></span>
        <mat-icon
            class="rw__bar-chevron"
            [svgIcon]="expanded ? 'heroicons_outline:chevron-down' : 'heroicons_outline:chevron-up'"
        ></mat-icon>
    </button>

    <div class="rw__panel" *ngIf="expanded">
        <div class="rw__panel-head">
            <div class="rw__day-nav">
                <button
                    mat-icon-button
                    type="button"
                    class="rw__day-nav-btn"
                    (click)="previousDay(); $event.stopPropagation()"
                    [matTooltip]="'Dia anterior' | autoTranslate"
                >
                    <mat-icon svgIcon="heroicons_outline:chevron-left"></mat-icon>
                </button>
                <span class="rw__day-nav-label" [class.rw__day-nav-label--today]="isToday">{{ dateLabel }}</span>
                <button
                    mat-icon-button
                    type="button"
                    class="rw__day-nav-btn"
                    (click)="nextDay(); $event.stopPropagation()"
                    [matTooltip]="'Próximo dia' | autoTranslate"
                >
                    <mat-icon svgIcon="heroicons_outline:chevron-right"></mat-icon>
                </button>
                <button
                    *ngIf="!isToday"
                    mat-stroked-button
                    type="button"
                    class="rw__day-nav-today"
                    (click)="goToToday(); $event.stopPropagation()"
                    autoTranslate
                >
                    Hoje
                </button>
            </div>
            <div class="rw__panel-head-right">
                <button
                    type="button"
                    class="rw__planned-toggle"
                    [class.rw__planned-toggle--active]="showPlanned"
                    (click)="togglePlanned(); $event.stopPropagation()"
                    role="switch"
                    [attr.aria-checked]="showPlanned"
                >
                    <span class="rw__planned-toggle-track">
                        <span class="rw__planned-toggle-thumb"></span>
                    </span>
                    <span autoTranslate>Mostrar Previstos</span>
                </button>
                <button
                    mat-icon-button
                    type="button"
                    class="rw__day-nav-btn rw__export-btn"
                    [disabled]="exporting"
                    (click)="exportReport(); $event.stopPropagation()"
                    [matTooltip]="'Exportar relatório do mês' | autoTranslate"
                >
                    <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                </button>
                <button
                    *ngIf="canEdit"
                    mat-mini-fab
                    type="button"
                    class="rw__add-btn"
                    [matMenuTriggerFor]="addMenu"
                    (click)="$event.stopPropagation()"
                    [matTooltip]="'Adicionar' | autoTranslate"
                >
                    <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                </button>
                <mat-menu #addMenu="matMenu">
                    <button mat-menu-item type="button" (click)="addPlanned()">
                        <span autoTranslate>Previsto</span>
                    </button>
                    <button mat-menu-item type="button" (click)="startNewAllocation()">
                        <span autoTranslate>Realizado</span>
                    </button>
                </mat-menu>
            </div>
        </div>

        <div *ngIf="loading" class="rw__empty">
            <span autoTranslate>Carregando...</span>
        </div>

        <div *ngIf="!loading && !timeline.sections.length" class="rw__empty">
            <span autoTranslate>Nenhum médico regulador alocado neste dia.</span>
        </div>

        <div *ngIf="!loading && timeline.sections.length" class="rw__scroll">
            <div class="rw__layout" [class.rw__layout--now]="timeline.nowLeftPct !== null">
                <aside class="rw__names">
                    <div class="rw__names-head"></div>
                    <div class="rw__names-body">
                        <ng-container *ngFor="let section of timeline.sections">
                            <div *ngIf="showPlanned" class="rw__name-cell rw__name-cell--sub" [style.height.px]="section.plannedLaneCount * 28"></div>
                            <div
                                class="rw__name-cell"
                                [class.rw__name-cell--sub]="showPlanned"
                                [style.height.px]="section.laneCount * 28"
                                [matTooltip]="section.companyName"
                            >
                                <span class="rw__row-name">{{ section.companyName }}</span>
                            </div>
                        </ng-container>
                    </div>
                </aside>

                <div class="rw__grid">
                    <div class="rw__head">
                        <div *ngFor="let h of hourColumns" class="rw__hour">{{ h }}h</div>
                    </div>

                    <div class="rw__body">
                        <ng-container *ngFor="let section of timeline.sections">
                            <div
                                *ngIf="showPlanned"
                                class="rw__row rw__row--planned"
                                [style.height.px]="section.plannedLaneCount * 28"
                            >
                                <div *ngFor="let h of hourColumns" class="rw__slot"></div>

                                <button
                                    type="button"
                                    *ngIf="canEdit"
                                    class="rw__lane-hit"
                                    [matTooltip]="'Adicionar previsto' | autoTranslate"
                                    (click)="addPlanned()"
                                ></button>

                                <span class="rw__row-tag" autoTranslate>Previsto</span>

                                <div
                                    *ngFor="let block of section.plannedBlocks"
                                    class="rw__card rw__card--planned"
                                    [style.left.%]="block.startPct"
                                    [style.width.%]="block.sizePct"
                                    [style.top.px]="block.lane * 28"
                                    [matTooltip]="block.tooltip"
                                    matTooltipClass="allocation-tooltip"
                                >{{ block.initials }}</div>
                            </div>
                            <div class="rw__row" [style.height.px]="section.laneCount * 28">
                                <div *ngFor="let h of hourColumns" class="rw__slot"></div>

                                <button
                                    type="button"
                                    *ngIf="canEdit"
                                    class="rw__lane-hit"
                                    [matTooltip]="'Iniciar plantão' | autoTranslate"
                                    (click)="startNewAllocation()"
                                ></button>

                                <span *ngIf="showPlanned" class="rw__row-tag" autoTranslate>Realizado</span>

                                <div
                                    *ngFor="let block of section.blocks"
                                    class="rw__card"
                                    [class.rw__card--open]="block.isOpen"
                                    [class.rw__card--clickable]="canEdit"
                                    [style.left.%]="block.startPct"
                                    [style.width.%]="block.sizePct"
                                    [style.top.px]="block.lane * 28"
                                    [matTooltip]="block.tooltip"
                                    matTooltipClass="allocation-tooltip"
                                    (click)="onBlockClick(block)"
                                >{{ block.initials }}</div>
                            </div>
                        </ng-container>
                    </div>

                    <div *ngIf="timeline.nowLeftPct !== null" class="rw__now" [style.left.%]="timeline.nowLeftPct">
                        <span class="rw__now-label" autoTranslate>Agora</span>
                        <span class="rw__now-line" aria-hidden="true"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
